import DynamicButton from './Button';
import React from 'react';
import { Box, withTheme } from '@material-ui/core';
import { ControlType } from '../api';
var DynamicMenuBar = function (_a) {
    var control = _a.control, dataState = _a.dataState, theme = _a.theme;
    return React.createElement(Box, { p: 2, bgcolor: theme.palette.background.default }, control.items
        .map(function (item, index) { return React.createElement(DynamicButton, { key: index, control: {
            kind: ControlType.Button,
            label: item.label,
            action: item
        }, dataState: dataState }); }));
};
export default withTheme(DynamicMenuBar);
//# sourceMappingURL=MenuBar.js.map